import { Layout } from 'antd';
import AppSidebar from 'layout/main/AppSidebar';
import AppHeader from 'layout/main/AppHeader';

const { Content } = Layout;

const AppLayout = ({ children }) => {
    return (
        <Layout className="abk-layout-wrap">
            <AppSidebar />
            <Layout>
                <AppHeader />
                <Content className="abk_layout">
                    <div style={{ height: '100%' }}>{children}</div>
                </Content>
            </Layout>
        </Layout>
    );
};

export default AppLayout;
